import React from 'react';
import PropTypes from 'prop-types';
import { TriStateButton } from '../styles';
import { SmallSeparator, ExternalLink } from '../../fees-and-pricing-components/styles';
import { recordStatisticsEvent } from '../../../../../services/statistics-service';
import { useIsXLarge } from '../../../../../shared/theme';

export default function Contact({ id, url, contact }) {
  const isDesktop = useIsXLarge();

  const externalLinkClick = e => {
    e && e.preventDefault();

    recordStatisticsEvent({
      event: 'fund_invest_modal_external_link_clicked',
      statisticable: 'fund',
      id,
      clicked_url: url,
      page: `${window.location.pathname}#invest-modal`,
    });

    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="contact">
      <SmallSeparator />

      <TriStateButton type="button" onClick={contact}>Contact</TriStateButton>

      {!!url && (
        <p className="external-link">
          <ExternalLink onClick={externalLinkClick} role="button" tabIndex={0}>
            <span className="icon-lw-external-link" />
            <span>{isDesktop ? 'Visit the website' : 'Visit website'}</span>
          </ExternalLink>
        </p>
      )}
    </div>
  );
}

Contact.propTypes = {
  id: PropTypes.number.isRequired,
  url: PropTypes.string,
  contact: PropTypes.func.isRequired,
};

Contact.defaultProps = { url: null };
